// Toast utility to provide consistent toast usage throughout the application
import { toast } from "react-toastify";

import { notifyUser } from "./notifyUser";

const showToast = (type, message, config = {}) =>
    notifyUser(
        config.toastId ?? null,
        type,
        message,
        "toast",
        null,
        null,
        config.autoClose ?? 5000,
        null,
        config.style?.minWidth ?? null,
        false,
        config.closeButton === false,
        "top-center",
    );

// Success toast with consistent styling
export const showSuccessToast = (message, config = {}) => {
    return showToast("success", message, config);
};

// Error toast with consistent styling
export const showErrorToast = (message, config = {}) => {
    return showToast("error", message, config);
};

// Info toast with consistent styling
export const showInfoToast = (message, config = {}) => {
    return showToast("info", message, config);
};

// Warning toast with consistent styling
export const showWarningToast = (message, config = {}) => {
    return showToast("warning", message, config);
};

// Dismiss all toasts
export const dismissAllToasts = () => {
    toast.dismiss();
};

// Clear waiting toasts - useful for resolving stuck toasts
export const clearWaitingToasts = () => {
    toast.clearWaitingQueue();
};

export default {
    success: showSuccessToast,
    error: showErrorToast,
    info: showInfoToast,
    warning: showWarningToast,
    dismiss: dismissAllToasts,
    clearQueue: clearWaitingToasts,
};
